<script setup>
// No custom tool yet (phase 4.7, D-G5): the kit's Empty over the kit's tools table, faded, with two neutral example
// tools (POLARIS.PAGES.EXAMPLES.TOOLS). The invitation that used to sit here is the page's Invitation.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import CustomToolsTable from 'dashboard/components-next/polaris/pageComponents/customTool/CustomToolsTable.vue';
import PolarisEmptyState from './PolarisEmptyState.vue';

const emit = defineEmits(['click']);

const { t, tm, rt } = useI18n();

const NOW = Math.floor(Date.now() / 1000);
const examples = computed(() =>
  tm('POLARIS.PAGES.EXAMPLES.TOOLS').map((example, index) => ({
    id: index + 1,
    title: rt(example.TITLE),
    description: rt(example.DESCRIPTION),
    endpoint_url: rt(example.URL),
    http_method: index ? 'POST' : 'GET',
    auth_type: index ? 'api_key' : 'bearer',
    updated_at: NOW - (index + 1) * 86400,
  }))
);
</script>

<template>
  <PolarisEmptyState
    :title="t('POLARIS.CUSTOM_TOOLS.EMPTY_STATE.TITLE')"
    :description="t('POLARIS.CUSTOM_TOOLS.EMPTY_STATE.SUBTITLE')"
    :action-label="t('POLARIS.CUSTOM_TOOLS.ADD_NEW')"
    :action-perms="['administrator']"
    @click="emit('click')"
  >
    <template #backdrop>
      <CustomToolsTable :tools="examples" />
    </template>
  </PolarisEmptyState>
</template>
